import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import House from './components/House';
import GoogleReviewsCarousel from './components/GoogleReviewsCarousel';
import LocationInfo from './components/LocationInfo';
import { LanguageProvider } from './context/LanguageContext';
import CalendarPopup from './components/CalendarPopup';
import Contact from './components/Contact';

function App() {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [selectedDates, setSelectedDates] = useState(null);

  // Airbnb base URL
  const airbnbBase = 'https://www.airbnb.gr/rooms/1294846092973024603';

  // Booking.com base URL
  const bookingBase = 'https://www.booking.com/hotel/gr/villa-irida-erakleio.el.html?aid=356980&label=gog235jc-1FCAsoXEIUdmlsbGEtaXJpZGEtZXJha2xlaW9ICFgDaFyIAQGYAQi4ARjIAQ_YAQHoAQH4AQKIAgGoAgS4AtaomcMGwAIB0gIkMTc4MTE5ODgtMzczYS00MzlhLTllZTUtZDk3ZGZmNTI0ZDQ02AIF4AIB&sid=06aaeecdd4cd12c37e9300eb6ddc7951&all_sr_blocks=1339530001_406467955_2_0_0_767508&dest_id=-827573&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=1339530001_406467955_2_0_0_767508&hpos=1&matching_block_id=1339530001_406467955_2_0_0_767508&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=1339530001_406467955_2_0_0_767508_20000&srepoch=1751537836&srpvid=d503462b0152032f&type=total&ucfs=1&';

  // YourRentals base URL
  const yourRentalsBase = 'https://app.your.rentals/p/114509?app_source=link_share';

  // Ημερομηνία σε YYYY-MM-DD (οι ημερομηνίες έρχονται ήδη κανονικοποιημένες στο μεσημέρι από το CalendarPopup)
  function formatDateForBooking(date) {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  // Τελευταία ημέρα που διάλεξε = τελευταία νύχτα. Check-out = επόμενη μέρα.
  function getCheckoutDate(lastNightDate) {
    const d = new Date(lastNightDate);
    d.setDate(d.getDate() + 1);
    return formatDateForBooking(d);
  }

  // Helper to build Airbnb URL with dates
  function getAirbnbUrl() {
    if (!selectedDates || !selectedDates[0] || !selectedDates[1]) return airbnbBase;
    const check_in = formatDateForBooking(selectedDates[0]);
    const check_out = getCheckoutDate(selectedDates[1]);
    return `${airbnbBase}?check_in=${check_in}&check_out=${check_out}&adults=1`;
  }

  // Helper to build Booking.com URL with dates
  function getBookingUrl() {
    if (!selectedDates || !selectedDates[0] || !selectedDates[1]) return bookingBase;
    const checkin = formatDateForBooking(selectedDates[0]);
    const checkout = getCheckoutDate(selectedDates[1]);
    return `${bookingBase}checkin=${checkin}&checkout=${checkout}`;
  }

  // Helper to build YourRentals URL with dates
  function getYourRentalsUrl() {
    if (!selectedDates || !selectedDates[0] || !selectedDates[1]) return yourRentalsBase;
    const check_in = formatDateForBooking(selectedDates[0]);
    const check_out = getCheckoutDate(selectedDates[1]);
    return `${yourRentalsBase}&check_in=${check_in}&check_out=${check_out}`;
  }

  const openInNewTab = (url) => window.open(url, '_blank', 'noopener,noreferrer');

  return (
    <LanguageProvider>
      <Router>
        <div className="font-sans text-gray-800 min-h-screen flex flex-col overflow-x-hidden">
          <Header />
          <main className="flex-1 flex flex-col">
              <Routes>
                <Route path="/" element={
                  <>
                    <Hero getAirbnbUrl={getAirbnbUrl} getBookingUrl={getBookingUrl} getYourRentalsUrl={getYourRentalsUrl} openInNewTab={openInNewTab} />
                    <GoogleReviewsCarousel />
                    <LocationInfo />
                  </>
                } />
                <Route path="/house" element={<House getAirbnbUrl={getAirbnbUrl} getBookingUrl={getBookingUrl} getYourRentalsUrl={getYourRentalsUrl} openInNewTab={openInNewTab} />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
          </main>
          <Footer />
        </div>
        <CalendarPopup 
          calendarOpen={calendarOpen}
          setCalendarOpen={setCalendarOpen}
          selectedDates={selectedDates}
          setSelectedDates={setSelectedDates}
          getAirbnbUrl={getAirbnbUrl}
          getBookingUrl={getBookingUrl}
          getYourRentalsUrl={getYourRentalsUrl}
          openInNewTab={openInNewTab}
        />
      </Router>
    </LanguageProvider>
  );
}

export default App;